<!-- <p-toast></p-toast> -->

<!-- <p-card styleClass="p-card-shadow"> -->
    <div class="dashboardTable">

        <p-table #ddReport [value]="reportData" dataKey="AppId_ProgID" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
        'PaymentFinYear',
		'AppID',
		'Lot_No',
		'Program_Name',
		'Status',
		'State_share_amt',
		'Centre_share_amt',
		'TopUp',
        'aby',
		'Refund_to_Farmer',
		'FarmerShare_to_Vendor',
		'Remarks',
		'CAORemarks',
        ]" responsiveLayout="scroll" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{ reportName }} ({{ 'FINANCIAL_YEAR' | translate}}: {{ reportYear }})</h5>
                    <span>
                        <button (click)="menu.toggle($event)" pButton pRipple label="{{'DOWNLOAD' | translate}}"
                            icon="pi pi-download" class="p-button-help"></button>

                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </span>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="ddReport.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th pFrozenColumn pSortableColumn="Srno">{{'SR_NO'| translate}}
                        <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                        <p-sortIcon field="Srno"></p-sortIcon>
                    </th> -->
                    <th pSortableColumn="AppID">{{'APP_ID'| translate}}</th>
                    <th pSortableColumn="Lot_No">{{'LOT_NO'| translate}}</th>
                    <th pSortableColumn="Program_Name">{{'PROGRAMME_NAME'| translate}}</th>
                    <th pSortableColumn="Status">{{'STATUS'| translate}}</th>
                    <th pSortableColumn="State_share_amt">{{'STATE_SHARE_AMOUNT'| translate}}</th>
                    <th pSortableColumn="Centre_share_amt">{{'CENTER_SHARE_AMOUNT'| translate}}</th>
                    <th pSortableColumn="TopUp">{{'TOP_UP'| translate}}</th>
                    <th pSortableColumn="aby">{{'ABY'| translate}}</th>
                    <th pSortableColumn="Refund_to_Farmer">{{'REFUND_TO_FARMER'| translate}}</th>
                    <th pSortableColumn="FarmerShare_to_Vendor">{{'FARMER_SHARE_TO_VENDOR'| translate}}</th>
                    <th pSortableColumn="Remarks">{{'REMARKS'| translate}}</th>
                    <th pSortableColumn="CAORemarks">{{'CAO_REMARKS'| translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <!-- <td pFrozenColumn>{{tankAbstract.Srno}}</td> -->
                    <td>{{data.AppID}}</td>
                    <td>{{data.Lot_No}}</td>
                    <td>{{data.Program_Name}}</td>
                    <td>{{data.Status}}</td>
                    <td>{{data.State_share_amt}}</td>
                    <td>{{data.Centre_share_amt}}</td>
                    <td>{{data.TopUp}}</td>
                    <td>{{data.aby}}</td>
                    <td>{{data.Refund_to_Farmer}}</td>
                    <td>{{data.FarmerShare_to_Vendor}}</td>
                    <td>{{data.Remarks}}</td>
                    <td>{{data.CAORemarks}}</td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{tankApp | number:'1.0-2'}}</td>
                <td >{{tankCoverageArea | number:'1.0-2'}}</td>
                <td >{{tankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{tankRpApp | number:'1.0-2'}}</td>
                <td >{{tankRejectedApp | number:'1.0-2'}}</td>
                <td >{{tankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td >{{grandTankApp | number:'1.0-2'}}</td>
                <td >{{grandTankCoverageArea | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{grandTankRpApp | number:'1.0-2'}}</td>
                <td >{{grandTankRejectedApp | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
        </ng-template> -->

        </p-table>
    </div>
<!-- </p-card> -->